import { defineNuxtRouteMiddleware, navigateTo } from '#imports';
import type { RouteLocationNormalized } from 'vue-router';
import { useAuthStore } from '~/stores/auth';
import { isPublicAuthPath } from '~/utils/auth/publicRoutes';

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
  const authStore = useAuthStore();

  if (!isPublicAuthPath(to.path) && !authStore.isAuthenticated) {
    return navigateTo('/login');
  }

  if (to.fullPath === '/') {
    return navigateTo('/owners');
  }
});
